import a from "tailwindcss/defaultTheme";
const n = {
  content: ["./src/**/*.{js,ts,jsx,tsx}"],
  theme: {
    extend: {
      animation: {
        progress: "progress 1s infinite linear;"
      },
      keyframes: {
        progress: {
          "0%": { transform: " translateX(0) scaleX(0)" },
          "40%": { transform: "translateX(0) scaleX(0.4)" },
          "100%": { transform: "translateX(100%) scaleX(0.5)" }
        }
      },
      transformOrigin: {
        "left-right": "0% 50%"
      },
      screens: {
        xs: "350px"
      },
      colors: {
        primary: "#1E429F",
        "norma-cyan": "#4EBFF1",
        "norma-purple": "#7767a0",
        "norma-fucsia": "#d42673",
        "norma-less-than-a1": "#FEACF1",
        "norma-a1": "#FE67E8",
        "norma-a2": "#75C5F1",
        "norma-a2-plus": "#4697C4",
        "norma-b1": "#C4AA44",
        "norma-b1-plus": "#FFBD59",
        "norma-b2": "#FF914D",
        "norma-b2-plus": "#E46D26",
        "norma-c1": "#7DD956",
        "norma-c2": "#00BE63",
        "norma-explorer": "#FE67E8",
        "norma-navigator": "#4697C4",
        "norma-pioneer": "#FFBD59",
        "norma-voyager": "#FF914D"
      },
      fontFamily: {
        sans: ['"Poppins"', ...a.fontFamily.sans]
      }
    }
  },
  plugins: []
};
export {
  n as default
};
